import { Badge } from '@/shared/components/ui/badge';
import type { FinancialAdvisorProfile } from '@/features/provider-directory/types/financial-advisor-profile.types';

type AdvisorProfileStatusBannerProps = {
  profile: FinancialAdvisorProfile;
};

export const AdvisorProfileStatusBanner = ({ profile }: AdvisorProfileStatusBannerProps) => {
  const isAdminHidden = profile.visibility?.hideFromServiceProviders === true;
  const isPrivate = profile.visibility?.profilePrivate === true;
  const isLive = profile.profileComplete && !isAdminHidden && !isPrivate;

  return (
    <div className="space-y-3">
      {isAdminHidden && (
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800">
          Your profile has been hidden by an administrator.
        </div>
      )}

      {!profile.profileComplete && (
        <div className="rounded-lg border border-yellow-200 bg-yellow-50 p-4">
          <div className="flex flex-wrap items-center gap-2">
            <Badge className="bg-yellow-100 text-yellow-700 hover:bg-yellow-100">
              Draft - Not Live
            </Badge>
            <p className="text-sm text-yellow-800">
              Complete the missing required fields to make your profile visible.
            </p>
          </div>
          {profile.missingRequiredFields.length > 0 && (
            <ul className="mt-3 list-disc pl-5 text-sm text-yellow-900">
              {profile.missingRequiredFields.map((field) => (
                <li key={field}>{field}</li>
              ))}
            </ul>
          )}
        </div>
      )}

      {isLive && (
        <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-4">
          <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100">Live</Badge>
          <span className="ml-2 text-sm text-emerald-800">
            Your profile is visible to Service Providers.
          </span>
        </div>
      )}

      {profile.profileComplete && isPrivate && !isAdminHidden && (
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
          Your profile is private and not visible to Service Providers.
        </div>
      )}
    </div>
  );
};
